import * as Yup from "yup";

export const followupVoiceSchema = Yup.object().shape({
  name: Yup.string()
    .max(100, "Cannot be more than 100 characters")
    .required("Program name is required"),
  followupPeriod: Yup.number()
    .required("Program period is required")
    .positive("Must be positive number"),
  notifyOnMissedTasksAfter: Yup.number()
    .required("Notification period is required")
    .positive("Must be positive number"),
  followupOn: Yup.array()
    .min(1, "At least one follow-up option must be selected")
    .required("Follow-up options are required"),
});
